<section [formGroup]="formGroup">
  <h2>{{ 'foreign_prescription_pharmacy_title' | locale }}</h2>
  @if (formGroup.enabled) {
    <p>{{ 'foreign_prescription_pharmacy_description' | locale }}</p>
  }

  <mat-label>{{ 'foreign_prescription_pharmacy_name' | locale }}</mat-label>
  <mat-form-field subscriptSizing="dynamic">
    <input #pharmacyNameInput matInput formControlName="pharmacyName" autocomplete="organization" [placeholder]="'foreign_prescription_pharmacy_name_placeholder' | locale" />
  </mat-form-field>

  <mat-label>{{ 'foreign_prescription_pharmacy_address' | locale }}</mat-label>
  <mat-form-field subscriptSizing="dynamic">
    <input matInput formControlName="pharmacyAddress" autocomplete="street-address" [placeholder]="'foreign_prescription_pharmacy_address_placeholder' | locale" />
  </mat-form-field>

  @if (formGroup.enabled) {
    <p class="pharmacy-notice">{{ 'foreign_prescription_pharmacy_finish_notice' | locale }}</p>
  }
</section>
